<template>
	<v-container fluid class="pa-0 white">
		<v-container
			fluid
			class="d-flex flex-wrap flex-md-nowrap flex-lg-nowrap"
			style="gap: 5px"
		>
			<v-autocomplete
				label="Range Type"
				rounded
				outlined
				dense
				hide-details
				:items="rangeTypes"
				v-model="rangeType"
				@change="updateDateRange"
			></v-autocomplete>
			<div
				v-if="rangeType != 'Date Range'"
				class="d-flex"
				style="min-width: 60%; gap: 5px"
			>
				<date-picker
					v-if="rangeType == 'By Month'"
					label="Month"
					v-model="selectedValue"
					@handle-change="updateDateRange"
				></date-picker>
				<date-picker
					v-if="rangeType == 'By Year'"
					label="Year"
					v-model="selectedValue"
					@handle-change="updateDateRange"
				></date-picker>
			</div>
			<div
				v-if="rangeType == 'Date Range'"
				class="d-flex"
				style="min-width: 60%; gap: 5px"
			>
				<date-picker
					label="Start Date"
					v-model="range.start"
				></date-picker>
				<date-picker label="End Date" v-model="range.end"></date-picker>
			</div>

			<v-btn
				depressed
				rounded
				color="primary"
				@click="getExpenses"
				:loading="isLoading"
				><i class="fas fa-arrow-right mr-2"></i>Go</v-btn
			>
		</v-container>

		<v-container fluid>
			<v-card elevation="0" class="rounded-xl" outlined>
				<v-card-title
					><span class="mr-1">Overview</span
					><span v-if="range.start && range.end"
						>- {{ convertToUsDate(range.start) }} to
						{{ convertToUsDate(range.end) }}</span
					><span v-else>- Life Time</span></v-card-title
				>
				<v-card-text
					class="d-flex justify-space-around flex-wrap flex-md-nowrap flex-lg-nowrap"
					style="gap: 5px"
				>
					<cash-flow-bar-card
						:data="cashFlowData"
					></cash-flow-bar-card>
					<v-card
						elevation="0"
						outlined
						class="rounded-xl"
						width="100%"
					>
						<v-card-title>Cash Flow</v-card-title>
						<v-card-text class="text-h4 d-flex">
							<div class="mr-2">
								${{ convertToCleanNumber(totalCashFlow) }}
							</div>
							<div>
								<i
									v-if="totalCashFlow > 0"
									class="fa-solid fa-chevron-up green--text"
								></i
								><i
									v-else-if="totalCashFlow < 0"
									class="fa-solid fa-chevron-down red--text"
								></i>
							</div>
						</v-card-text>
						<v-card-text class="text-h6 d-flex">
							<v-container class="pa-0">
								<div>Total Expenses</div>
								<div class="mr-2 orange--text">
									${{ convertToCleanNumber(totalExpense) }}
								</div>
							</v-container>
							<v-container class="pa-0">
								<div>Total Refunds</div>
								<div class="mr-2 orange--text">
									${{
										convertToCleanNumber(
											totalRefund.mul(-1)
										)
									}}
								</div>
							</v-container>
						</v-card-text>

						<v-card-text
							class="text-h6 d-flex justify-space-between"
						>
							<div>
								<div>Total Paid Sales</div>
								<div class="mr-2" style="color: #1f7a1f">
									${{
										convertToCleanNumber(
											totalSales.minus(totalPendingSales)
										)
									}}
								</div>
							</div>
							<div>
								<div>Total Dong Credits</div>
								<div style="color: #1f7a1f">
									{{ getCurrencySymbol(Dong)
									}}{{
										convertToCleanNumber(
											credits['dongCredits'],
											false
										)
									}}
								</div>
							</div>
							<div>
								<div>Total Dollar Credits</div>
								<div style="color: #1f7a1f">
									{{ getCurrencySymbol(Dollar)
									}}{{
										convertToCleanNumber(
											credits['dollarCredits']
										)
									}}
								</div>
							</div>
						</v-card-text>
					</v-card>
					<v-card
						elevation="0"
						outlined
						class="rounded-xl"
						width="100%"
					>
						<v-card-title>Total Sales</v-card-title>
						<v-card-text class="text-h4"
							>${{
								convertToCleanNumber(totalSales)
							}}</v-card-text
						>
						<v-card-text class="text-h6">
							<div>Total Paid Sales</div>
							<div class="mr-2" style="color: #1f7a1f">
								${{
									convertToCleanNumber(
										totalSales.minus(totalPendingSales)
									)
								}}
							</div>
						</v-card-text>
						<v-card-text class="text-h6">
							<div>Total Pending Sales</div>
							<div class="mr-2" style="color: #98e698">
								${{ convertToCleanNumber(totalPendingSales) }}
							</div>
						</v-card-text>
					</v-card>
				</v-card-text>
			</v-card>
		</v-container>
		<v-container
			fluid
			class="d-flex justify-space-between flex-wrap flex-md-nowrap flex-lg-nowrap"
			style="gap: 5px"
		>
			<pie-card class="mr-2" :data="pieData"></pie-card>
			<bar-card class="mr-2" :data="barData"></bar-card>
			<line-card :data="lineData"></line-card>
		</v-container>
		<v-container fluid class="pa-0">
			<v-card
				elevation="0"
				class="rounded-xl overflow-y-auto"
				outlined
				width="100%"
				style="height: 400px"
			>
				<v-card-text>
					<v-row>
						<v-col cols="10" class="text-h5 text-center"
							>Top Purchased Products</v-col
						>
						<v-col cols="2" class="text-h5">Qty</v-col>
					</v-row>
					<v-row
						v-for="rank in productRankings"
						:key="rank.id"
						style="border-bottom: 1px lightgray solid"
					>
						<v-col
							cols="10"
							class="d-flex align-center"
							style="gap: 10px"
						>
							<div>
								<img
									class="image-preview"
									:src="
										getProductPictureUrlById(rank.pictureId)
									"
								/>
							</div>
							<div>{{ rank.title }}</div>
						</v-col>
						<v-col cols="2" class="d-flex align-center text-h5">
							{{ rank.quantity }}
						</v-col>
					</v-row>
				</v-card-text>
			</v-card>
		</v-container>
	</v-container>
</template>
<script>
import PieCard from './PieCard.vue';
import BarCard from './BarCard.vue';
import CashFlowBarCard from './CashFlowBarCard.vue';
import LineCard from './LineCard.vue';
import backendService from '@/services/backend-service';
import DatePicker from './DatePicker.vue';
import Decimal from 'decimal.js';
import { PaymentStatus } from '@/js/enum.js';
import generalMixin from '@/js/general-mixin';
export default {
	name: 'CashFlowChart',
	mixins: [generalMixin],
	props: {},
	components: {
		'pie-card': PieCard,
		'bar-card': BarCard,
		'cash-flow-bar-card': CashFlowBarCard,
		'line-card': LineCard,
		'date-picker': DatePicker,
	},
	mounted: function () {
		this.getExpenses();
		this.getTotalCredits();
	},
	data() {
		return {
			rangeTypes: [
				'Date Range',
				'By Month',
				'By Year',
				'Last Year',
				'This Year',
				'Last Week',
				'Last Month',
				'Last 3 Months',
				'Last 6 Months',
				'Last 12 Months',
			],
			rangeType: 'Date Range',
			productRankings: [],
			selectedValue: null,
			selectedYear: null,
			isLoading: false,
			totalExpense: new Decimal(0),
			totalSales: new Decimal(0),
			totalCashFlow: new Decimal(0),
			totalRefund: new Decimal(0),
			totalPendingSales: new Decimal(0),
			credits: {},
			expenses: [],
			invoices: [],
			range: {},
			barData: {
				labels: [],
				datasets: [
					{
						label: '',
						backgroundColor: '',
						data: [],
					},
				],
			},
			cashFlowData: {
				labels: [],
				datasets: [
					{
						label: '',
						backgroundColor: '',
						data: [],
					},
				],
			},
			lineData: {
				labels: [],
				datasets: [
					{
						label: '',
						backgroundColor: '',
						data: [],
					},
				],
			},
			pieData: {
				labels: [],
				datasets: [
					{
						label: '',
						backgroundColor: '',
						data: [],
					},
				],
			},
		};
	},
	computed: {
		Paid() {
			return this.getIdByEnum(PaymentStatus.Paid);
		},
		PartiallyPaid() {
			return this.getIdByEnum(PaymentStatus.PartiallyPaid);
		},
	},
	methods: {
		getExpenses() {
			this.isLoading = true;
			let range = null;
			let filter = null;
			if (this.range.start && this.range.end) {
				range = this.range;
				filter = {};
				filter.startDate = this.range.start;
				filter.endDate = this.range.end;
			}
			let promises = [];
			let promise = backendService.getExpenses(range).then((response) => {
				this.expenses = response.data;
			});
			promises.push(promise);
			promise = backendService.getInvoices(range).then((response) => {
				this.invoices = response.data;
			});
			promises.push(promise);
			promise = backendService
				.getProductRankings(filter)
				.then((response) => {
					this.productRankings = response.data;
				});
			promises.push(promise);
			Promise.all([promises]).then(() => {
				this.timer(1000).then(() => {
					this.isLoading = false;
					this.getBarChartData();
					this.getPieChartData();
				});
			});
		},
		getPieChartData() {
			let expenses = this.expenses;
			let data = [];
			let labels = [];
			let dict = {};
			for (let i = 0; i < expenses.length; i++) {
				let expense = expenses[i];
				let type = this.getOptionName(expense.typeId);
				if (!dict[type]) {
					dict[type] = new Decimal(0);
				}
				let amount = new Decimal(expense.amount);
				dict[type] = dict[type].plus(amount);
			}
			labels = Object.keys(dict).sort();
			for (let i = 0; i < labels.length; i++) {
				data.push(parseFloat(dict[labels[i]].toFixed(2)));
			}
			let datasets = [
				{
					backgroundColor: [
						'#ff5454',
						'#ff9354',
						'#d7ff54',
						'#54ffac',
						'#54e8ff',
						'#a454ff',
						'#ff54ff',
					],
					data: data,
				},
			];

			this.pieData = {
				labels: labels,
				datasets: datasets,
			};
			this.$forceUpdate();
		},
		getBarChartData() {
			let expenses = this.expenses;
			let invoices = this.invoices;
			let uniqueLabels = {};
			let labels = [];
			let diffDict = {};
			let expenseDict = {};
			let invoiceDict = {};
			let datasets = [];
			let lineDatasets = [];
			this.totalExpense = new Decimal(0);
			this.totalRefund = new Decimal(0);
			this.totalPendingSales = new Decimal(0);
			this.totalCashFlow = new Decimal(0);
			this.totalSales = new Decimal(0);
			//find expense data
			for (let i = 0; i < expenses.length; i++) {
				let expense = expenses[i];
				let dateArr = expense.transactionDate.split('-');
				let dateStr = `${dateArr[0]}/${dateArr[1]}`;
				if (!expenseDict[dateStr]) {
					expenseDict[dateStr] = new Decimal(0);
				}
				if (!diffDict[dateStr]) {
					diffDict[dateStr] = new Decimal(0);
				}
				let amount = new Decimal(expense.amount);
				this.totalCashFlow = this.totalCashFlow.minus(amount);
				this.totalExpense = this.totalExpense.plus(amount);

				if (amount < 0) {
					this.totalRefund = this.totalRefund.plus(amount);
				}
				expenseDict[dateStr] = expenseDict[dateStr].plus(amount);
				diffDict[dateStr] = diffDict[dateStr].minus(amount);
			}
			labels = Object.keys(expenseDict).sort();
			for (let i = 0; i < labels.length; i++) {
				uniqueLabels[labels[i]] = true;
			}
			//find earning data
			for (let i = 0; i < invoices.length; i++) {
				let invoice = invoices[i];
				let dateArr = invoice.dateCreated.split('-');
				let dateStr = `${dateArr[0]}/${dateArr[1]}`;
				if (!invoiceDict[dateStr]) {
					invoiceDict[dateStr] = new Decimal(0);
				}
				if (!diffDict[dateStr]) {
					diffDict[dateStr] = new Decimal(0);
				}
				let amount = new Decimal(invoice.totalAmount);
				let sum = new Decimal(invoice.amountPaid).plus(
					new Decimal(invoice.creditPaid)
				);
				if (invoice.currencyId == this.Dong) {
					amount = this.convertToUsDollar(invoice.totalAmount);
					sum = this.convertToUsDollar(
						invoice.amountPaid + invoice.creditPaid
					);
				}
				this.totalSales = this.totalSales.plus(amount);

				if (invoice.paymentStatusId == this.Paid)
					this.totalCashFlow = this.totalCashFlow.plus(amount);
				else if (invoice.paymentStatusId == this.PartiallyPaid) {
					this.totalCashFlow = this.totalCashFlow.plus(sum);
					this.totalPendingSales = this.totalPendingSales.plus(
						amount.minus(sum)
					);
				} else {
					this.totalPendingSales =
						this.totalPendingSales.plus(amount);
				}

				invoiceDict[dateStr] = invoiceDict[dateStr].plus(amount);
				diffDict[dateStr] = diffDict[dateStr].plus(amount);
			}
			labels = Object.keys(invoiceDict).sort();
			for (let i = 0; i < labels.length; i++) {
				uniqueLabels[labels[i]] = true;
			}
			labels = Object.keys(uniqueLabels).sort();
			let expenseData = [];
			let invoiceData = [];
			let diffData = [];
			for (let i = 0; i < labels.length; i++) {
				let dateStr = labels[i];
				if (!expenseDict[dateStr]) {
					expenseData.push(0);
				} else {
					expenseData.push(expenseDict[dateStr].toFixed(2));
				}
				if (!invoiceDict[dateStr]) {
					invoiceData.push(0);
				} else {
					invoiceData.push(invoiceDict[dateStr].toFixed(2));
				}
				if (!diffDict[dateStr]) {
					diffData.push(0);
				} else {
					diffData.push(diffDict[dateStr].toFixed(2));
				}
			}
			datasets.push({
				label: 'Expense',
				backgroundColor: '#ffae45',
				data: expenseData,
			});
			datasets.push({
				label: 'Earning',
				backgroundColor: '#5786ff',
				data: invoiceData,
			});
			lineDatasets.push({
				label: 'Expense',
				borderColor: '#ffae45',
				data: expenseData,
				tension: 0.1,
			});
			lineDatasets.push({
				label: 'Earning',
				borderColor: '#5786ff',
				data: invoiceData,
				tension: 0.1,
			});
			lineDatasets.push({
				label: 'Cashflow',
				borderColor: '#1f7a1f',
				data: diffData,
				tension: 0.1,
			});
			this.barData = {
				labels: Object.keys(uniqueLabels).sort(),
				datasets: datasets,
			};
			this.lineData = {
				labels: Object.keys(uniqueLabels).sort(),
				datasets: lineDatasets,
			};

			this.cashFlowData = {
				labels: ['Expense', 'Sale'],
				datasets: [
					{
						label: 'Expense',
						data: [this.totalExpense.toFixed(2), 0],
						backgroundColor: '#ffae45',
					},
					{
						label: 'Paid',
						data: [
							0,
							this.totalSales
								.minus(this.totalPendingSales)
								.toFixed(2),
						],
						backgroundColor: '#1f7a1f',
					},
					{
						label: 'Pending',
						data: [0, this.totalPendingSales.toFixed(2)],
						backgroundColor: '#98e698',
					},
				],
			};
			this.$forceUpdate();
		},
		getLineChartData() {
			let expenses = this.expenses;
			let data = [];
			let labels = [];
			let dict = {};
			for (let i = 0; i < expenses.length; i++) {
				let expense = expenses[i];
				let dateArr = expense.transactionDate.split('-');
				let dateStr = `${dateArr[0]}/${dateArr[1]}`;
				if (!dict[dateStr]) {
					dict[dateStr] = new Decimal(0);
				}
				let amount = new Decimal(expense.amount);
				dict[dateStr] = dict[dateStr].plus(amount);
			}
			labels = Object.keys(dict).sort();
			for (let i = 0; i < labels.length; i++) {
				data.push(parseFloat(dict[labels[i]].toFixed(2)));
			}
			let datasets = [
				{
					backgroundColor: '#FFAB5B',
					data: data,
				},
			];

			this.lineData = {
				labels: labels,
				datasets: datasets,
			};
			this.$forceUpdate();
		},
		getProductPictureUrlById(imageId) {
			return backendService.getProductPictureUrlById(imageId);
		},
		getTotalCredits() {
			backendService.getTotalCredits().then((response) => {
				this.credits = response.data;
			});
		},
		updateDateRange() {
			if (this.rangeType == 'By Month') {
				let selectedDate = new Date(this.selectedValue + 'T00:00:00');
				const monthIdx = selectedDate.getMonth();
				const year = selectedDate.getFullYear();
				let startDate = new Date(year, monthIdx, 1);
				let endDate = new Date(year, monthIdx + 1, 1);

				this.range.start = startDate.toISOString().split('T')[0];
				this.range.end = endDate.toISOString().split('T')[0];
			} else if (this.rangeType == 'By Year') {
				let selectedDate = new Date(this.selectedValue + 'T00:00:00');
				const year = selectedDate.getFullYear();
				let startDate = new Date(year, 0, 1);
				let endDate = new Date(year + 1, 0, 1);
				this.range.start = startDate.toISOString().split('T')[0];
				this.range.end = endDate.toISOString().split('T')[0];
			} else if (this.rangeType == 'Last Year') {
				let today = new Date();
				let thisYear = today.getFullYear();
				let lastYear = today.getFullYear() - 1;
				let startDate = new Date(lastYear, 0, 1);
				let endDate = new Date(thisYear, 0, 1);
				this.range.start = startDate.toISOString().split('T')[0];
				this.range.end = endDate.toISOString().split('T')[0];
				this.getExpenses();
			} else if (this.rangeType == 'This Year') {
				let today = new Date();
				let thisYear = today.getFullYear();
				let startDate = new Date(thisYear, 0, 1);
				let endDate = new Date(thisYear + 1, 0, 1);
				this.range.start = startDate.toISOString().split('T')[0];
				this.range.end = endDate.toISOString().split('T')[0];
				this.getExpenses();
			} else if (this.rangeType == 'Last Week') {
				let today = new Date();
				let dayOfWeek = today.getDay();
				let endOfLastWeek = new Date(today);
				endOfLastWeek.setDate(today.getDate() - dayOfWeek);
				let startOfLastWeek = new Date(endOfLastWeek);
				startOfLastWeek.setDate(startOfLastWeek.getDate() - 7);

				this.range.start = startOfLastWeek.toISOString().split('T')[0];
				this.range.end = endOfLastWeek.toISOString().split('T')[0];
				this.getExpenses();
			} else if (this.rangeType == 'Last Month') {
				let today = new Date();
				let endOfLastMonth = new Date(
					today.getFullYear(),
					today.getMonth(),
					1
				);
				let dayBeforeEndOfLastMonth = new Date(endOfLastMonth - 1);
				let startOfLastMonth = new Date(
					dayBeforeEndOfLastMonth.getFullYear(),
					dayBeforeEndOfLastMonth.getMonth(),
					1
				);
				this.range.start = startOfLastMonth.toISOString().split('T')[0];
				this.range.end = endOfLastMonth.toISOString().split('T')[0];
				this.getExpenses();
			} else if (this.rangeType == 'Last 3 Months') {
				let today = new Date();
				let end = new Date(today.getFullYear(), today.getMonth(), 1);
				let start = new Date(end);
				start.setMonth(start.getMonth() - 3);
				this.range.start = start.toISOString().split('T')[0];
				this.range.end = end.toISOString().split('T')[0];
				this.getExpenses();
			} else if (this.rangeType == 'Last 6 Months') {
				let today = new Date();
				let end = new Date(today.getFullYear(), today.getMonth(), 1);
				let start = new Date(end);
				start.setMonth(start.getMonth() - 6);
				this.range.start = start.toISOString().split('T')[0];
				this.range.end = end.toISOString().split('T')[0];
				this.getExpenses();
				this.getExpenses();
			} else if (this.rangeType == 'Last 12 Months') {
				let today = new Date();
				let end = new Date(today.getFullYear(), today.getMonth(), 1);
				let start = new Date(end);
				start.setMonth(start.getMonth() - 12);
				this.range.start = start.toISOString().split('T')[0];
				this.range.end = end.toISOString().split('T')[0];
				this.getExpenses();
			}
		},
	},
};
</script>
<style></style>
